import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of } from 'rxjs';
import {
  GlobalNotificationCreate,
  GlobalNotificationCreateFail,
  GlobalNotificationCreateSuccess,
  GlobalNotificationDelete,
  GlobalNotificationDeleteFail,
  GlobalNotificationDeleteSuccess,
  GlobalNotificationsActionTypes,
  GlobalNotificationsLoad,
  GlobalNotificationsLoadFail,
  GlobalNotificationsLoadSuccess,
} from '@completion/actions';
import { GlobalNotificationService } from '../../services/global-notification.service';

@Injectable()
export class GlobalNotificationsEffect {
  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GlobalNotificationsLoad>(GlobalNotificationsActionTypes.Load),
      exhaustMap(() =>
        this.service.getAll().pipe(
          map((notifications) => new GlobalNotificationsLoadSuccess(notifications)),
          catchError((error) => of(new GlobalNotificationsLoadFail(error))),
        ),
      ),
    ),
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GlobalNotificationCreate>(GlobalNotificationsActionTypes.Create),
      exhaustMap((action) =>
        this.service.create(action.notification).pipe(
          map((notification) => new GlobalNotificationCreateSuccess(notification)),
          catchError((error) => of(new GlobalNotificationCreateFail(error))),
        ),
      ),
    ),
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GlobalNotificationDelete>(GlobalNotificationsActionTypes.Delete),
      exhaustMap((action) =>
        this.service.delete(action.notification.id).pipe(
          map(() => new GlobalNotificationDeleteSuccess(action.notification.id)),
          catchError((error) => of(new GlobalNotificationDeleteFail(error))),
        ),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly service: GlobalNotificationService,
  ) {}
}
